namespace GeniuzPOS.Inventory {
    export interface IcStockReturnOutDtForm {
        Id: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        SkuCode: Serenity.LookupEditor;
        ItemRemark: Serenity.StringEditor;
        UnitChange: Serenity.EnumEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        CostValue: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        ExpDate: Serenity.DateEditor;
        Remark: Serenity.StringEditor;
        GRRefFg: Serenity.StringEditor;
        GRLineId: Serenity.StringEditor;
    }

    export class IcStockReturnOutDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockReturnOutDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockReturnOutDtForm.init)  {
                IcStockReturnOutDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.DateEditor;

                Q.initFormType(IcStockReturnOutDtForm, [
                    'Id', w0,
                    'LineItemNo', w0,
                    'SkuCode', w1,
                    'ItemRemark', w2,
                    'UnitChange', w3,
                    'PurUnit', w2,
                    'PurUnitRatio', w4,
                    'PurUnitPrice', w4,
                    'Qty', w4,
                    'CostValue', w4,
                    'UnitCost', w4,
                    'ExpDate', w5,
                    'Remark', w2,
                    'GRRefFg', w2,
                    'GRLineId', w2
                ]);
            }
        }
    }
}
